import Component from './PageDivider'

export default Component
